import Grid from '@mui/material/Grid';
import settings from '/@/core/settings';
import Title from '/@/v3/components/title';

const CropMonitoringDetail = ({ icon, title, data, color = false }) => {
    return (
        <Grid container alignItems='center' sx={{ gap: '5px' }}>
            <Grid item>
                <i style={{ fontSize: '14px', display: 'flex', alignItems: 'flex-end' }} className='material-icons'>
                    {icon}
                </i>
            </Grid>
            <Grid item>
                <Title size='sm' color='dark'>
                    {title}:
                </Title>
            </Grid>
            <Grid item>
                <Title size='sm' bolder color='dark' theme={color ? settings.app.theme : null}>
                    {data}
                </Title>
            </Grid>
        </Grid>
    );
};

export default CropMonitoringDetail;
